export default function Phone2Svg() {
  return (
    <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.625 1.625c3.75 0 6.75 3 6.75 6.75m-6.75-3c1.5 0 3 1.5 3 3m-15-6.75c0 12.75 6 18.75 18.75 18.75v-6l-5.25-1.5-1.5 2.25c-3 0-6.75-3.75-6.75-6.75l2.25-1.5-1.5-5.25h-6z"
        stroke="#10C6BE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
